import dayjs, { Dayjs } from "dayjs";

export const getDateRange = (selected: string, calendarDate: Dayjs | null) => {
  const now = dayjs();

  switch (selected) {
    case "today":
      return { from: now.startOf("day"), to: now.endOf("day") };

    case "last_week":
      // últimos 7 días (incluye hora)
      return {
        from: now.subtract(7, "day").startOf("day"),
        to: now.endOf("day"),
      };

    case "last_month":
      return {
        from: now.subtract(1, "month").startOf("day"),
        to: now.endOf("day"),
      };

    case "calendar":
      if (!calendarDate) return null;
      return {
        from: calendarDate.startOf("day"),
        to: calendarDate.endOf("day"),
      };

    default:
      return null; // all_dates
  }
};
